import React from 'react';
import Link from 'next/link';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './saveCompletePage.module.scss';
const cx = classnames.bind(styles);

const SaveCompletePage = () => {
  return (
    <div className={cx('saveCompletePageArea')}>
      <div className={cx('logo')}>
        <span className={cx('hidden')}>JOBDA</span>
      </div>

      <em className={cx('title')}>
        취업 기회를 잡다
        <br />
        합격 순간을 잡다
      </em>

      <p className={cx('desc')}>
        성공적으로 역검 결과 저장이 완료되었습니다.
        <br />
        잡다에서 역검 결과를 확인해 보세요!
      </p>

      <Link href={RouteUrl.ACCA_TEST_GATE} legacyBehavior>
        <a className={cx('btn')} role="button">
          잡다로 이동하기
        </a>
      </Link>
    </div>
  );
};

export default SaveCompletePage;
